export enum ModificationPointType {
  TopLeft = "topLeft",
  TopRight = "topRight",
  BottomRight = "bottomRight",
  BottomLeft = "bottomLeft",
  ChamferEdgeLeft = "chamferEdgeLeft",
  ChamferEdgeRight = "chamferEdgeRight",
  ArchEdgeLeft = "archEdgeLeft",
}